import React, { useState } from 'react';
import img1 from '../components/images/esl/Nebular_collection.jpg'
import img2 from '../components/images/esl/polaris.webp'
import img3 from '../components/images/esl/lumina_collection.jpg'

const ProductShowcase = () => {
  const [activeTab, setActiveTab] = useState('nebular');
  
  // Using placeholder images for demo - replace with your actual imports
  
  const productData = {
    nebular: {
      title: 'NEBULAR',
      subtitle: 'Redefining the future of ESL solutions with Hanshow\'s newest technology and innovation, Hanshow Nebular digital price tag is an upgrade in every way, with proprietary SIP ultra-low power design, extended battery life, and sleek unibody design.',
      buttonText: 'DISCOVER NEBULAR',
      image: img1,
      features: ['Ultra-low power design', 'Extended battery life', 'Sleek unibody design', 'Proprietary SIP technology'],
      data1: 'Normal - 3 Colors',
      data2: 'Pro - 4 Colors'
    },
    polaris: {
      title: 'POLARIS PRO',
      subtitle: 'Advanced ESL solution featuring cutting-edge display technology and enhanced connectivity. Polaris Pro offers superior performance with crystal-clear displays, robust wireless communication, and enterprise-grade reliability for demanding retail environments.',
      buttonText: 'DISCOVER POLARIS PRO',
      image: img2,
      features: ['Crystal-clear displays', 'Enhanced connectivity', 'Enterprise-grade reliability', 'Advanced wireless communication'],
      data1:'Multicolor',
      data2:'7 Flashing LEDs',
    },
    lumina: {
      title: 'LUMINA AQUA',
      subtitle: 'Next-generation ESL platform with innovative aqua-inspired design and smart features. Lumina Aqua combines elegant aesthetics with powerful functionality, delivering exceptional visibility and seamless integration for modern retail spaces.',
      buttonText: 'DISCOVER LUMINA AQUA',
      image: img3,
      features: ['Aqua-inspired design', 'Smart features', 'Exceptional visibility', 'Seamless integration'],
      data1: 'Likely 3 color',
      data2: 'flash support'
    }
  };

  const currentProduct = productData[activeTab];

  return (
    <div className="w-full bg-gray-100 min-h-screen py-12 font-poppins">
      <div className="container mx-auto px-4 max-w-7xl">
        {/* Tab Navigation */}
        <div className="flex justify-center mb-12">
          <div className="w-full max-w-2xl">
            <div className="flex bg-white rounded-full p-1 shadow-sm gap-1">
              {Object.entries(productData).map(([key, product]) => (
                <button
                  key={key}
                  className={`flex-1 px-4 py-3 font-bold text-sm uppercase transition-all duration-300 tracking-wide rounded-full ${
                    activeTab === key 
                      ? 'text-white bg-blue-600 shadow-md' 
                      : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                  }`}
                  onClick={() => setActiveTab(key)}
                >
                  {product.title}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex flex-col lg:flex-row items-center min-h-[50vh] gap-8 ml-5">
          {/* Text Content */}
          <div className="w-full lg:w-1/2 lg:pr-8">
            <h1 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-blue-600 mb-6 tracking-wider">
              {currentProduct.title}
            </h1>
            
            <div className="mb-6">
              <div className="h-1 w-20 bg-blue-600 rounded-full"></div>
            </div>

            <p className="text-xl text-gray-600 mb-6 leading-relaxed">
              {currentProduct.subtitle}
            </p>

            {/* Features */}
            <div className="mb-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {currentProduct.features.map((feature, index) => (
                  <div key={index} className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-2"></div>
                    <span className="text-gray-600 text-sm">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            <button 
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-full text-sm uppercase tracking-wide shadow-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl"
              onClick={() => window.open('https://www.hanshow.com/en','_blank')}
            >
              {currentProduct.buttonText} →
            </button>
          </div>

          {/* Image Content */}
          <div className="w-full lg:w-1/2">
            <div className="relative">
              <div 
                className="bg-white rounded-2xl shadow-2xl p-6 transition-all duration-500"
                style={{
                  transform: 'perspective(1000px) rotateY(-5deg) rotateX(2deg)',
                }}
              >
                <img
                  src={currentProduct.image}
                  alt={currentProduct.title}
                  className="w-full h-96 object-contain rounded-xl transition-all duration-500"
                />
                
                {/* Product Cards Scattered */}
                <div 
                  className="absolute bottom-5 left-5 bg-white shadow-lg rounded-lg p-3 w-32 transform -rotate-3"
                >
                  <div className="text-center">
                    <div className="bg-red-500 text-white rounded px-2 py-1 text-xs mb-1">
                      {currentProduct.data1}
                    </div>
                    <div className="text-gray-600 text-xs">{currentProduct.data2}</div>
                  </div>
                </div>
              </div>

              {/* Background Decorative Elements */}
              {/* <div 
                className="absolute w-48 h-48 bg-blue-600 rounded-full opacity-10 -top-12 -right-12 -z-10"
              ></div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductShowcase;